import { manageQAModalActionTypes } from './Constants';

const initialState = {
	settings: {
		open: false,
		list: [],
		currentItem: null,
		componentData: {},
	},
	loading: false,
};

export default function resultsModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case manageQAModalActionTypes.SET_MANAGE_MODAL:
			return {
				...state,
				settings: { ...state.settings, ...data },
			};
		case manageQAModalActionTypes.CLEAR_MANAGE_MODAL_DATA:
			return initialState;
		default:
			return state;
	}
}
